import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-filter-panel',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule],
  templateUrl: './filter-panel.component.html',
  styleUrl: './filter-panel.component.scss',
})
export class FilterPanelComponent {
  @Input() numberOfResults: number = 0;
  @Input() activeFilterCount: number = 0;

  @Output() apply = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  isOpen = false;

  togglePanel(): void {
    if (this.isOpen) {
      this.cancel.emit();
    }
    this.isOpen = !this.isOpen;
  }

  onApply(): void {
    this.apply.emit();
    this.isOpen = false;
  }

  onCancel(): void {
    this.cancel.emit();
    this.isOpen = false;
  }
}
